import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import flex from '@/css/module/flex.css';
import QueryTimer from '@/components/QueryTimer';
import { dataTableInteraction } from '@/actions';
import { selectQueryStartTime } from '@/features/query-builder/queryBuilderSlice';

export const LoadingTimer = () => {
  const dispatch = useDispatch();
  const timerStart = useSelector(selectQueryStartTime);
  const handleDataTableInteraction = (props: unknown) => {
    dispatch(dataTableInteraction(props));
  };

  return (
    <div className={flex.middle}>
      <div className={`${flex.column} ${flex.alignItemsCenter}`}>
        <QueryTimer
          onInteraction={handleDataTableInteraction}
          timerStart={timerStart}
        />
      </div>
    </div>
  );
};
